import { DOMAIN } from '../config/domain'
import { store } from '../App'
import { SET_CAFE_STATUS } from '../store/cafe/actionTypes'

export function db(method, endpoint, body) {
    const token = store.getState().config.token
    let parsedBody = body ? { body: JSON.stringify(body) } : null;

    let jsonResponse = {
        code: '400',
        errorCode: 'BAD_REQUEST',
        errors: [{ code: 'UNKNOWN_ERROR', message: 'Unknown error' }]
    }

    return fetch(
        DOMAIN + endpoint, {
        method: method,
        dataType: 'json',
        ...parsedBody,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => response.json())
        .catch((err) => {
            console.error(err)
            store.dispatch({ type: SET_CAFE_STATUS, cafeStatus: err })
            return jsonResponse
        })
}
